import { Card } from "primereact/card";
import { QuestionResponse } from "../models";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
export default function LicensingInfoComponent({ response, dataSource, downLoadProviderDataByDataSource }:
    {
        response: QuestionResponse[], dataSource: string, downLoadProviderDataByDataSource: (dataSource: string) => void

    }) {

    const fieldName = response && response.length > 0 ? response[0].fieldName : '';

    const getTableData = () => {
        let requiredData = response && response.length > 0 ? response[0].fieldValue : null;
        let data = requiredData ? JSON.parse(requiredData) : null;
        return data;
    }

    const isValidStatus = (status: string) => {
        switch (dataSource.toUpperCase()) {
            case 'CLS':
                return !['RVK', 'EXP'].includes(status?.toUpperCase());
            default:
                return [];
        }
    }

    const downloadDataSource = () => {
        downLoadProviderDataByDataSource(dataSource);
    }


    const renderData = () => {
        let data = getTableData()
        if (data.length > 0) {
            return (
                <Card>
                    <div style={{ margin: '10px' }}>
                        <div className="p-field-checkbox" style={{ margin: '10px' }}>
                            <Checkbox inputId="yes" checked={data.every((item: any) => isValidStatus(item[fieldName]))} disabled />
                            <label htmlFor="yes"> Yes</label>
                        </div>
                        <div className="p-field-checkbox" style={{ margin: '10px' }}>
                            <Checkbox inputId="no" checked={data.some((item: any) => !isValidStatus(item[fieldName]))} disabled />
                            <label htmlFor="no"> No</label>
                        </div>
                    </div>

                    <DataTable
                        showGridlines
                        value={data}
                    >
                        {
                            Object.keys(data[0]).map((k: string, index) => (
                                <Column key={index} field={k} header={k}></Column>
                            ))
                        }
                    </DataTable>

                    <div style={{ marginTop: '20px' }}>
                        <a onClick={downloadDataSource} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>Download CLS Extract</a>
                    </div>

                </Card >)
        }
        return (
            <>N/A</>
        )
    }

    return (
        <>{renderData()}</>
    )
}